const getDateStringFromIsoFormat = (date: string) => {
  return date.split("T")[0].split("-").reverse().join(".")
}

export default getDateStringFromIsoFormat
